import { observable } from 'mobx';

import { ApiUrls } from '@app/AppConstants/ApiUrls';
import ApiService from '@app/Services/ApiService';
import { applyDecorators } from '@app/Helpers/Decorator';

export type TimeTransitionEvent = {
    timeUtc: Date;
    minutesUtcTimeDiff: number;
};

export class SwissTimeTransitionsStore {
    @observable.ref public swissTransitions: TimeTransitionEvent[] = [];
    public swissTransitionsYearsLoaded: Map<number, TimeTransitionEvent[] | null> = new Map();
    
    constructor () {
        applyDecorators(this);
    }
    
    public loadTransitions(dateUtc: Date) {
        const year = dateUtc.getUTCFullYear();
        if (this.swissTransitionsYearsLoaded.has(year)) {
            return;
        }

        void (async () => {
            await this._loadTransitions(dateUtc);
        })();
    }

    public async loadTransitionsAsync(dateUtc: Date) {
        const year = dateUtc.getUTCFullYear();
        if (this.swissTransitionsYearsLoaded.has(year)) {
            return Promise.resolve();
        }

        await this._loadTransitions(dateUtc);
    }

    private async _loadTransitions(dateUtc: Date) {
        const year = dateUtc.getUTCFullYear();

        this.swissTransitionsYearsLoaded.set(year, null);
        try {
            const request = {
                periodFrom: new Date(dateUtc.getUTCFullYear() - 2, 0, 1),
                periodTo: new Date(dateUtc.getUTCFullYear() + 2, 0, 1)
            };
            const { data } = await ApiService.getTypedData<TimeTransitionEvent[]>(ApiUrls.TimeSwissTransitions, request);

            this.swissTransitionsYearsLoaded.set(year, data);

            this._rebuildTransitions();
        } catch (e) {
            this.swissTransitionsYearsLoaded.delete(year);
            throw e;
        }
    }

    private _rebuildTransitions() {
        const transitionsMap: Map<number, TimeTransitionEvent> = new Map();
        for (const [, events] of this.swissTransitionsYearsLoaded) {
            if (!events) continue;

            for (const event of events) {
                transitionsMap.set(event.timeUtc.getTime(), event);
            }
        }

        const transitions = [...transitionsMap.values()];
        transitions.sort((e1, e2) => e1.timeUtc.getTime() - e2.timeUtc.getTime());

        this.swissTransitions = transitions;
    }
}